<template>
  <rizhi ref="aaaa"> </rizhi>
</template>
<script>
import rizhi from "../../../node_modules/common/src/components/log/loginLog";
import axios from "axios"
export default {
  components: { rizhi },
  data() {
    return {
      canshu:{
        axios:axios,
        param:{},
      }
    }
  },
  methods: {
    addd(){
      this.$refs.aaaa.reMsg(this.canshu)
    }
  },
  mounted() {
    setTimeout(() => {
      //this.addd();
    }, 500);
    
  },
};
</script>


// WEBPACK FOOTER //
// src/components/user/loginLog.vue